export enum screenStatusTypes {
  SET_SCREEN_STATUS = "SET_SCREEN_STATUS",
}
